import { BusinessSessionBridge } from './BusinessSessionBridge'
export default function BusinessLogout({ onCompleted }: { onCompleted?: () => void }) {
  return <BusinessSessionBridge clear onCompleted={onCompleted} />
}
